<ng-container>
    <app-loader></app-loader>
</ng-container>
